<!--
  @Description 富文本html展示封装，因为富文本内样式可能不相同，使用一个组件封起来 导入富文本样式保证展示和输入是一样的
  @Date 2022-10-25
  @Author liufu
-->
<template>
  <div v-html="html" class="ql-editor"></div>
</template>
<script>
export default {
  props: {
    html: {
      type: String,
      default: ''
    }
  }
}
</script>
<style scoped>
.ql-editor {
  padding: 0 !important;
}
@import '../richEditorCss/quill.bubble.css';
@import '../richEditorCss/quill.core.css';
@import '../richEditorCss/quill.snow.css';
</style>
